import { render, staticRenderFns } from "./sk-radio.vue?vue&type=template&id=f19a1176&scoped=true&"
import script from "./sk-radio.vue?vue&type=script&lang=js&"
export * from "./sk-radio.vue?vue&type=script&lang=js&"
import style0 from "./sk-radio.vue?vue&type=style&index=0&id=f19a1176&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f19a1176",
  null
  
)

export default component.exports